import axiosInstance from './AxiosInstance';
import qs from 'qs';

export default class EventRegisterService {
    constructor() {
        this.endpoint = "/api/registerManagement"
    }

    async getAll(params) {
        try {
            const response = await axiosInstance.get(this.endpoint, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async  GetLiveVoterRegister(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/live/register`, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    async GetRegisterByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async create(data) {
        try {
            const response = await axiosInstance.post(this.endpoint, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    
    
    async saveSignature(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/signatures`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    
    async edit(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/edit`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async activate(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/deactivate`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    
    async  updateRegister(data,id) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    async certifyRegister(data,id) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}/${id}/certify`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    //Place holder

    

          //Place holder

      async getRegisterByEventID(data) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}/event/${data?.eventID}`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
      }
}

const eventRegisterService = new EventRegisterService();

export { eventRegisterService };